// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"111":"5173399e","172":"e3f74b3d","640":"9e029802"}[chunkId] + ".chunk.js";
};